import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import App from './App'
import Home from './components/Home'
import Overview from './components/Overview/Overview'
import Technologies from './components/Technologies/Technologies'
import TechnologiesOverview from './components/Technologies/TechnologiesOverview'
import Java from './components/Technologies/Java'
import DotNet from './components/Technologies/DotNet'
import Web from './components/Technologies/Web'
import Mobile from './components/Technologies/Mobile'
import Data from './components/Technologies/Data'
import Analysis from './components/Technologies/Analysis'
import Fun from './components/Technologies/Fun'
import Initiatives from './components/Initiatives/Initiatives'
import InitiativesOverview from './components/Initiatives/InitiativesOverview'
import DevDay from './components/Initiatives/DevDay'
import TechAccelerator from './components/Initiatives/TechAccelerator'
import EntelectChallenge from './components/Initiatives/EntelectChallenge'
import Bootcamp from './components/Initiatives/Bootcamp'
import Contributions from './components/Contributions/Contributions'
import Events from './components/Events/Events'
import Thanks from './components/Thanks/Thanks'
import Whoops from './components/Whoops'

Vue.config.productionTip = false;

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: Home,
        props: {transparentHeader: true},
        children: [
            {path: '', component: Overview},
            {
                path: 'technologies', component: Technologies,
                children: [
                    {path: '', component: TechnologiesOverview},
                    {path: 'java', component: Java},
                    {path: 'dotnet', component: DotNet},
                    {path: 'web', component: Web},
                    {path: 'mobile', component: Mobile},
                    {path: 'data', component: Data},
                    {path: 'analysis', component: Analysis},
                    {path: 'fun', component: Fun},
                ]
            },
            {
                path: 'initiatives', component: Initiatives,
                children: [
                    {path: '', component: InitiativesOverview},
                    {path: 'devday', component: DevDay},
                    {path: 'accelerator', component: TechAccelerator},
                    {path: 'challenge', component: EntelectChallenge},
                    {path: 'bootcamp', component: Bootcamp},
                ]
            },
            {path: 'contributions', component: Contributions},
            {path: 'events', component: Events},
            {path: 'thanks', component: Thanks},
            {path: '/*', component: Whoops},
        ]
    }
];

const router = new VueRouter({
    routes, // short for `routes: routes`
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    mode: 'history'
});

Vue.use(VueAnalytics, {
    id: 'UA-48292067-6',
    router
});

new Vue({
    render: h => h(App),
    router
}).$mount('#app');
